import { BinsoObject, ParlorDetailProps, ServiceObject } from "@/types/parlor";
import {
  // Button,
  ColorIcon,
  colors,
  customEvent,
  // FUNERAL_SIDO,
  // FUNERAL_SIGUNGU,
  // getCdnImageSrc,
  // HLine,
  // Image,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  SERVICE_DETAILS_2026_BASE,
  Spacing,
} from "goi_common";
import { Dispatch, SetStateAction } from "react";
import { BaseStack } from "goi_common/src/design-system";
import {
  Box,
  Flex,
  VStack,
  HStack,
  // CircularProgress, Button
} from "@chakra-ui/react";

import GoiMessage from "@/containers/HomeContainer/components/GoiMessage";
import SelectedReviews from "@/components/common/SelectedReviews";
import ParlorRequestBox from "../../ParlorRequestBox/ParlorRequestBox";
import MubinsoQuickCard from "../../../../ParlorRegionContainer/components/MubinsoQuickCard";
import { ABEnabledContainer } from "@/components/ABEnabledContainer";
import { isPriceDisclosureParlor } from "@/utils/parlorPriceDisclosure";
import ParlorPriceDisclosureSection from "../../ParlorPriceDisclosureSection";

// import { ReviewCardRenewal } from "@/containers/ReviewContainer/components/ReviewSmallCarousel/ReviewCard";

interface PriceInfoPanelProps {
  expectedCharges: {
    [type: string]: number;
  };
  binsos: Array<BinsoObject>;
  services: ServiceObject;
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  setSelectedSangjo: Dispatch<SetStateAction<string>>;
  discountDescription?: string;
  closestParlors: any;
  isExcluded?: boolean;
  isSimple?: boolean;
}

function PriceInfoTabPanel({
  expectedCharges,

  parlor,
}: PriceInfoPanelProps) {
  return (
    <VStack height="100%">
      <ThisParlorContent231101 expectedCharges={expectedCharges} parlor={parlor} />
    </VStack>
  );
}

type ThisParlorContent231101Props = object & ThisParlorCTACard231101Props;

const ThisParlorContent231101 = ({ expectedCharges, parlor }: ThisParlorContent231101Props) => {
  return (
    <>
      <>
        <ThisParlorCTACard231101 expectedCharges={expectedCharges} parlor={parlor} />

        <Spacing gap={36} />

        <>
          <NextLink
            href="/funeral-prepare/1?utm_source=platform&utm_medium=parlor_detail"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "parlor_detail",
                  trigger_and_target: "content-uv_funeral_prepare_1",
                },
              });
            }}
          >
            <Box className="subtitle_14_sb orange650" textAlign={"center"}>
              처음하는 장례 준비 어떻게 해야 후회 없을까요? &gt;
            </Box>
          </NextLink>
          <Spacing gap={36} />
          <ParlorRequestBox
            sido={parlor.sido}
            sigungu={parlor.sigungu}
            companyName={parlor.companyname}
          />
        </>
      </>
      <Spacing gap={36} />
      <VStack width="100%" textAlign="start" padding="24px " background={colors.gray50}>
        <Box className="body_16_m gray800" width="100%">
          <b>작은 장례부터, 마음을 담은 고품격 장례까지,</b> <br />
          고이에서 제공하는 서비스를 소개해드릴게요
        </Box>
      </VStack>
      <VStack width="100%" padding="0px 24px" justifyContent="start" alignItems="start">
        <HStack width="100%" alignItems="start" justifyContent="center" marginTop="40px !important">
          {Object.entries(SERVICE_DETAILS_2026_BASE).map(([key, details]) => {
            const isSelected = key === "가족장";
            const backgroundColor = isSelected ? colors.orange150 : "";
            const color = isSelected ? colors.orange650 : colors.gray600;

            const [type, premium] = details.type.split(" ");

            return (
              <VStack key={key} justifyContent="center">
                <Flex
                  className="subtitle_14_sb"
                  alignItems="center"
                  flexDirection="column"
                  justifyContent="center"
                  textAlign="center"
                  color={color}
                  height="45px"
                  position="relative"
                >
                  {isSelected && (
                    <Box
                      position="absolute"
                      top={premium ? "-20px" : "-10px"}
                      left="calc(50% - 9px)"
                    >
                      <ColorIcon name="icon-circle-check-mono" color={color} size={18} />
                    </Box>
                  )}
                  <Box
                    className={`${isSelected ? "subtitle_14_b" : "subtitle_14_sb"}`}
                    whiteSpace="pre-wrap"
                    color={color}
                    lineHeight="18px"
                  >
                    {`${type}\n${premium || ""}`}
                  </Box>
                </Flex>
                <VStack
                  padding="24px 0px"
                  gap="16px"
                  backgroundColor={backgroundColor}
                  color={color}
                  width="58px"
                  border={isSelected ? "none" : `1px solid ${colors.gray100}`}
                  borderRadius="6px"
                >
                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      접객도우미
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["접객도우미"] || "없음"}
                    </Box>
                  </VStack>

                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      장례 용품
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["장례 용품"]}
                    </Box>
                  </VStack>

                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      장의차량
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["장의 차량"]}대
                    </Box>
                  </VStack>
                </VStack>
                <VStack>
                  <Box
                    className={isSelected ? "subtitle_14_b" : "body_14_m"}
                    css={{
                      color,
                    }}
                  >
                    {details?.최종할인가 || details.가격}만원
                  </Box>
                  {premium && (
                    <Box
                      className="caption_11_r gray600"
                      padding="4px 6px"
                      borderRadius="11px"
                      color={colors.orange650}
                      backgroundColor={colors.orange150}
                      marginTop="2px !important"
                    >
                      10% 할인
                    </Box>
                  )}
                </VStack>
              </VStack>
            );
          })}
        </HStack>
        <Spacing gap={12} />
        <NextLink
          href={`/service/`}
          css={{
            width: "100%",
          }}
          onClick={() => {
            customEvent({
              newGtm: { path: "parlor_detail", trigger_and_target: "uv_service" },
            });
          }}
        >
          <HStack width="100%" justifyContent="end">
            <span className="caption_12_b orange650">전체 서비스 상세히 살펴보기</span>
            <ColorIcon name="icon-arrow-right-circle-mono" color={colors.orange600} size={12} />
          </HStack>
        </NextLink>

        <Box padding="24px 12px 6px" width="100%" className="gray600 body_14_m">
          작은 장례에는 <b>고이장례연구소 가족장</b>을 추천드려요
        </Box>
        <Spacing gap={12} />
        <VStack width="100%" gap="12px">
          <NextLink href={`/match/parlor-requests/${parlor.id}/?utm_campaign=parlor`}>
            <LargeButton
              css={{ padding: "16px 20px" }}
              buttonType={LARGEL_BUTTON_TYPE.PRIMARY}
              onClick={() => {
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
                });
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
                });
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "CTA-uv_match_request_top",
                  },
                });
              }}
            >
              <HStack gap={10}>
                <span className="button_14_sb white">장례 절차, 비용을 알고 싶다면?</span>
                <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
              </HStack>
            </LargeButton>
          </NextLink>
        </VStack>
        <Spacing gap={36} />
      </VStack>

      <VStack width="100%" textAlign="start" padding="24px " background={colors.gray50}>
        <Box className="body_16_m gray800" width="100%">
          <b>한번 뿐인 장례, 다른 가족의 후기를 꼭 확인하세요</b> <br />
          <span className="caption_12_b">
            (*해당 장례식장이 아닌 고이장례연구소 이용 후기입니다.)
          </span>
        </Box>
      </VStack>
      <Spacing gap={6} />
      <VStack padding="6px 16px">
        <SelectedReviews
          title={<>후기 평균 4.9점, 진짜 고객이 말합니다.</>}
          path="parlor_detail"
          headingAs="h2"
        />
      </VStack>

      <Box width="100%">
        <GoiMessage
          event={{
            path: "parlor_detail",
            trigger_and_target: "uv_intro",
          }}
          title={
            <>
              숨김없는 장례의 시작 <br />
              고이장례연구소
            </>
          }
        />
      </Box>
    </>
  );
};

interface ThisParlorCTACard231101Props {
  expectedCharges: {
    [type: string]: number;
  };
  parlor: ParlorDetailProps;
}

const toManwon = (won: number) => `${Math.round(won / 10000).toLocaleString()}만원`;

const ThisParlorCTACard231101 = ({ expectedCharges, parlor }: ThisParlorContent231101Props) => {
  // const 시도 = FUNERAL_SIDO.get(Number(parlor.sido));
  // const 시군구 = FUNERAL_SIGUNGU.get(Number(parlor.sido))?.get(Number(parlor.sigungu));

  return (
    <>
      <VStack width="100%" gap="16px" padding="0 16px">
        <h2 css={{ paddingTop: "30px" }} className="subtitle_21_b gray900">
          {parlor.companyname} 장례식장 비용
        </h2>
        {/*
          장례식장별 숫자는 크게 보여주되, 리드 목적상 딱 잘라 한 값으로 보여주지 않고
          조문객 없을 때(무빈소)와 있을 때(가족장~일반장 범위)로 나눠 상세 비용 버튼으로 유도한다. 짝수, 홀수 공통
        */}
        <BaseStack width="100%" spacing={8}>
          <BaseStack
            direction="horizontal"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            padding="14px 16px"
            borderRadius={12}
            background={colors.gray50}
          >
            <span className="body_14_m gray700">조문객이 없을 때 (무빈소)</span>
            <span className="subtitle_16_b gray900">{toManwon(expectedCharges["무빈소"])}</span>
          </BaseStack>
          {/* 무빈소를 모르는 사람이 많아, 설명과 가능 여부 확인을 무빈소 견적 흐름(template=mubinso)으로 잇는다 */}
          <NextLink
            href={`/match/request/?template=mubinso&utm_campaign=parlor_cost_card&utm_content=${parlor.id}`}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "parlor_detail",
                  trigger_and_target: "cost-mubinso_req",
                  properties: { parlor_id: parlor.id },
                },
              });
            }}
          >
            <BaseStack
              direction="horizontal"
              width="100%"
              justifyContent="flex-end"
              alignItems="center"
              spacing={2}
              padding="0 4px"
            >
              <span className="caption_12_m gray600">
                무빈소가 무엇인가요? 무빈소로 진행할 수 있는지 확인해 보세요
              </span>
              <ColorIcon name="icon-arrow-right-small-mono" color={colors.gray600} size={14} />
            </BaseStack>
          </NextLink>
          <BaseStack
            width="100%"
            spacing={4}
            padding="18px 16px"
            borderRadius={12}
            background={colors.orange50}
            alignItems="center"
          >
            <span className="body_14_m gray700">조문객이 있을 때 (가족장 ~ 일반장)</span>
            <span className="subtitle_21_b orange650">
              {toManwon(expectedCharges["가족장"])} ~ {toManwon(expectedCharges["일반장"])}
            </span>
          </BaseStack>
        </BaseStack>
        <Box lineHeight="20px" className="body_14_m gray700" textAlign="center">
          {/*
            이 카드와 견적 화면(/match/parlor-requests/{id}) 모두 "장례식장 비용" 을 다룬다(상조 제외).
            "전체 장례 비용" 을 메인으로 쓰지 않는다 (2026-10-08 영민 결정)
          */}
          빈소, 안치, 음식 등 장례식장에서 발생할 수 있는 비용이에요.
          <br />
          조문객 수, 진행 방식 등에 따라 비용이 달라질 수 있기에
          <br />
          아래 버튼을 통해 확인하실 수 있어요.
          <br />
          (e하늘 장사정보시스템 기반 고이장례연구소 추산)
        </Box>

        <NextLink href={`/match/parlor-requests/${parlor.id}/?utm_campaign=parlor`}>
          <LargeButton
            css={{ padding: "16px 20px" }}
            buttonType={LARGEL_BUTTON_TYPE.GRAY900}
            onClick={() => {
              customEvent({
                newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
              });
              customEvent({
                newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
              });
              customEvent({
                newGtm: {
                  path: "parlor_detail",
                  trigger_and_target: "CTA-uv_match_request_bottom",
                },
              });
            }}
          >
            <HStack gap={10}>
              <span className="button_16_sb white">상세 비용 알아보기</span>
              <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
            </HStack>
          </LargeButton>
        </NextLink>
        <Spacing gap={6} />
      </VStack>

      {/* {variation === "B" && (
        <VStack width="100%" gap="16px" padding="0 16px">
          <h3 css={{ paddingTop: "30px" }} className="subtitle_21_b gray900">
            장례식장 예상 비용
          </h3>
          <Box textAlign="center" padding="0 8px">
            <span className="subtitle_18_b orange650">
              {expectedCharges["무빈소"].toLocaleString()}원 ~{" "}
              {expectedCharges["일반장"].toLocaleString()}원
            </span>
            <br />
            <br />
            <span className="body_14_m gray800">
              위 비용은 장례용품(인력, 관, 수의, 차량)을 제외한,
              <br />
              조문객 수에 따른 장례식장 예상 비용입니다.
              <br />
              전체 장례 비용(장지, 장례용품 등), 상세 장례비용을 더 알아보세요
            </span>
            <br />
            <br />
          </Box>

          <NextLink
            href={`/match/parlor-requests/${parlor.id}/?utm_campaign=parlor`}
            css={{
              marginTop: "0px !important",
            }}
          >
            <LargeButton
              css={{ padding: "16px 20px" }}
              buttonType={LARGEL_BUTTON_TYPE.GRAY900}
              onClick={() => {
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
                });
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
                });
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "CTA-uv_match_request_bottom",
                  },
                });
              }}
            >
              <HStack gap={10}>
                <span className="button_16_sb white">상세 비용 알아보기</span>
                <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
              </HStack>
            </LargeButton>
          </NextLink>

          <Box lineHeight="18px" className="body_14_m gray600">
            * e하늘 장사정보시스템 공공 데이터를 기반으로
            <br />
            &nbsp;&nbsp;&nbsp;<b className="gray900">고이장례연구소</b>에서 추산한 장례식장 예상
            비용입니다.
            <br />
            <Spacing gap={6} />
          </Box>
        </VStack>
      )} */}

      {/* 160 실험 버전 B 코드
       {variation === "B" && (
        <VStack width="100%">
          <VStack width="100%" gap={0} padding="0 20px">
            <h3 css={{ paddingTop: "30px" }} className="subtitle_18_sb gray900">
              장례식장 예상 비용
            </h3>
            <Box
              width="100%"
              textAlign="center"
              padding="20px"
              background={colors.gray50}
              borderRadius={6}
            >
              <span className="subtitle_21_sb orange700">
                {expectedCharges["무빈소"].toLocaleString()}원 ~{" "}
                {expectedCharges["일반장"].toLocaleString()}원
              </span>
              <Spacing gap={8} />
              <Box className="caption_12_r gray700">
                e하늘 장사정보시스템 공공데이터 기반으로 추산한
                <br />
                예상비용으로, 실제 비용과 다를 수 있습니다.
              </Box>
            </Box>

            <Spacing gap={12} />
            <Box className="body_16_r gray700" textAlign="center">
              빈소 평형, 조문객 수 등을 고려한
              <br />더 정확한 비용을 확인해 보세요.
            </Box>
            <Spacing gap={12} />

            <NextLink href={`/match/parlor-requests/${parlor.id}/?utm_campaign=parlor`}>
              <LargeButton
                css={{ padding: "16px 20px" }}
                buttonType={LARGEL_BUTTON_TYPE.ORANGE}
                onClick={() => {
                  customEvent({
                    newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
                  });
                  customEvent({
                    newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
                  });
                  customEvent({
                    newGtm: {
                      path: "parlor_detail",
                      trigger_and_target: "CTA-uv_match_request_bottom",
                    },
                  });
                }}
              >
                <span className="body_16_m white">상세 비용 알아보기</span>
              </LargeButton>
            </NextLink>
            <Spacing gap={40} />
            <HLine height={1} width="100%" color={colors.gray200} />
            <Spacing gap={40} />
            <VStack width="100%" textAlign="center">
              <Box className="subtitle_18_sb gray900">
                {시도} {시군구}의
                <br />
                장례식장 정보가 필요하신가요?
              </Box>
              <Spacing gap={12} />
              <VStack
                width="100%"
                textAlign="center"
                padding="20px"
                background={colors.gray50}
                borderRadius={6}
                gap="16px"
              >
                <Image
                  width="48px"
                  height="48x"
                  src={getCdnImageSrc("platform/home/comparison.png")}
                />

                <Box width="100%" textAlign="center" className="body_16_r gray700">
                  {시도} {시군구}에 있는 장례식장 평균 비용과
                  <br />
                  가장 저렴한 장례식장 정보를 확인해 보세요.
                </Box>
                <NextLink href={`/parlors/region/${시도}-${시군구}`}>
                  <LargeButton
                    css={{ padding: "16px 20px" }}
                    buttonType={LARGEL_BUTTON_TYPE.WHITE}
                    onClick={() => {
                      customEvent({
                        newGtm: { path: "parlor_detail", trigger_and_target: "compare-CTA" },
                      });
                    }}
                  >
                    <span className="body_16_m gray900">다른 장례식장 비용 비교하기</span>
                  </LargeButton>
                </NextLink>
              </VStack>
            </VStack>
            <Spacing gap={56} />
          </VStack>

          <HLine height="12px" color={colors.gray50} width="100%" />
        </VStack>
      )} */}
      {/* {variation === "Z" && (
        <Flex
          width="100%"
          minHeight="600px"
          textAlign="center"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress isIndeterminate color={colors.gray50} />
        </Flex>
      )} */}
    </>
  );
};

export const PriceTopSection = ({
  expectedCharges,
  parlor,
}: {
  expectedCharges: { [type: string]: number };
  parlor: ParlorDetailProps;
}) => {
  return (
    <VStack height="100%">
      <ThisParlorCTACard231101 expectedCharges={expectedCharges} parlor={parlor} />
      <Spacing gap={36} />
      <NextLink
        href="/funeral-prepare/1?utm_source=platform&utm_medium=parlor_detail"
        onClick={() => {
          customEvent({
            newGtm: {
              path: "parlor_detail",
              trigger_and_target: "content-uv_funeral_prepare_1",
            },
          });
        }}
      >
        <Box className="subtitle_14_sb orange650" textAlign={"center"}>
          처음하는 장례 준비 어떻게 해야 후회 없을까요? &gt;
        </Box>
      </NextLink>
      <Spacing gap={36} />
      <ParlorRequestBox
        sido={parlor.sido}
        sigungu={parlor.sigungu}
        companyName={parlor.companyname}
      />
      <Spacing gap={36} />
      {/* 무빈소 가능 여부 빠른 확인 카드 (상세 NotSafe 전용, #320 A/B). A=미노출 / B=노출 */}
      <ABEnabledContainer
        experimentKey={320}
        ComponentA={<></>}
        ComponentB={
          <MubinsoQuickCard
            variant="hero"
            purpose="mubinso"
            heroBadge="무빈소"
            heroTitle={
              <>
                {parlor.companyname},
                <br />
                무빈소로도 가능할까요?
              </>
            }
            heroDescription="빈소 없이 간소하게 모시는 방법과 예상 비용을 확인해보세요."
            defaultSido={parlor.sido != null ? Number(parlor.sido) : null}
            defaultSigungu={parlor.sigungu != null ? Number(parlor.sigungu) : null}
            hideRegion
            loginEventFrom="parlor_detail"
            submitText="무빈소 가능 여부 확인하기"
            eventConfig={{
              path: "parlor_detail",
              sidoTrigger: "mbn_card-sido",
              sigunguTrigger: "mbn_card-sgg",
              statusTrigger: "mbn_card-status",
              submitTrigger: "mbn_card-submit",
            }}
            memo={`${parlor.companyname} 페이지에서 바로 제출한 고객이며 무빈소 니즈가 있을 수 있습니다.`}
            parlorName={parlor.companyname}
          />
        }
      />
      <Spacing gap={36} />
      {/* 견적 폼과 #320 카드 뒤, 지도 바로 위. 폼 바로 아래에 두면 #320 카드 위치가 밀려 그 실험이 오염된다 */}
      {isPriceDisclosureParlor(parlor) && <ParlorPriceDisclosureSection parlor={parlor} />}
    </VStack>
  );
};

export const GoiIntroSection = ({ parlor }: { parlor: ParlorDetailProps }) => {
  return (
    <>
      <VStack width="100%" textAlign="start" padding="24px " background={colors.gray50}>
        <Box className="body_16_m gray800" width="100%">
          <b>작은 장례부터, 마음을 담은 고품격 장례까지,</b> <br />
          고이에서 제공하는 서비스를 소개해드릴게요
        </Box>
      </VStack>
      <VStack width="100%" padding="0px 24px" justifyContent="start" alignItems="start">
        <HStack width="100%" alignItems="start" justifyContent="center" marginTop="40px !important">
          {Object.entries(SERVICE_DETAILS_2026_BASE).map(([key, details]) => {
            const isSelected = key === "가족장";
            const backgroundColor = isSelected ? colors.orange150 : "";
            const color = isSelected ? colors.orange650 : colors.gray600;
            const [type, premium] = details.type.split(" ");
            return (
              <VStack key={key} justifyContent="center">
                <Flex
                  className="subtitle_14_sb"
                  alignItems="center"
                  flexDirection="column"
                  justifyContent="center"
                  textAlign="center"
                  color={color}
                  height="45px"
                  position="relative"
                >
                  {isSelected && (
                    <Box
                      position="absolute"
                      top={premium ? "-20px" : "-10px"}
                      left="calc(50% - 9px)"
                    >
                      <ColorIcon name="icon-circle-check-mono" color={color} size={18} />
                    </Box>
                  )}
                  <Box
                    className={`${isSelected ? "subtitle_14_b" : "subtitle_14_sb"}`}
                    whiteSpace="pre-wrap"
                    color={color}
                    lineHeight="18px"
                  >
                    {`${type}\n${premium || ""}`}
                  </Box>
                </Flex>
                <VStack
                  padding="24px 0px"
                  gap="16px"
                  backgroundColor={backgroundColor}
                  color={color}
                  width="58px"
                  border={isSelected ? "none" : `1px solid ${colors.gray100}`}
                  borderRadius="6px"
                >
                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      접객도우미
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["접객도우미"] || "없음"}
                    </Box>
                  </VStack>
                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      장례 용품
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["장례 용품"]}
                    </Box>
                  </VStack>
                  <VStack>
                    <Box className="caption_11_r" color={color}>
                      장의차량
                    </Box>
                    <Box className="body_14_m" marginTop="0px !important">
                      {details["장의 차량"]}대
                    </Box>
                  </VStack>
                </VStack>
                <VStack>
                  <Box className={isSelected ? "subtitle_14_b" : "body_14_m"} css={{ color }}>
                    {details?.최종할인가 || details.가격}만원
                  </Box>
                  {premium && (
                    <Box
                      className="caption_11_r gray600"
                      padding="4px 6px"
                      borderRadius="11px"
                      color={colors.orange650}
                      backgroundColor={colors.orange150}
                      marginTop="2px !important"
                    >
                      10% 할인
                    </Box>
                  )}
                </VStack>
              </VStack>
            );
          })}
        </HStack>
        <Spacing gap={12} />
        <NextLink
          href={`/service/`}
          css={{ width: "100%" }}
          onClick={() => {
            customEvent({
              newGtm: { path: "parlor_detail", trigger_and_target: "uv_service" },
            });
          }}
        >
          <HStack width="100%" justifyContent="end">
            <span className="caption_12_b orange650">전체 서비스 상세히 살펴보기</span>
            <ColorIcon name="icon-arrow-right-circle-mono" color={colors.orange600} size={12} />
          </HStack>
        </NextLink>
        <Box padding="24px 12px 6px" width="100%" className="gray600 body_14_m">
          작은 장례에는 <b>고이장례연구소 가족장</b>을 추천드려요
        </Box>
        <Spacing gap={12} />
        <VStack width="100%" gap="12px">
          <NextLink href={`/match/parlor-requests/${parlor.id}/?utm_campaign=parlor`}>
            <LargeButton
              css={{ padding: "16px 20px" }}
              buttonType={LARGEL_BUTTON_TYPE.PRIMARY}
              onClick={() => {
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
                });
                customEvent({
                  newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
                });
                customEvent({
                  newGtm: {
                    path: "parlor_detail",
                    trigger_and_target: "CTA-uv_match_request_top",
                  },
                });
              }}
            >
              <HStack gap={10}>
                <span className="button_14_sb white">장례 절차, 비용을 알고 싶다면?</span>
                <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
              </HStack>
            </LargeButton>
          </NextLink>
        </VStack>
        <Spacing gap={36} />
      </VStack>

      <VStack width="100%" textAlign="start" padding="24px " background={colors.gray50}>
        <Box className="body_16_m gray800" width="100%">
          <b>한번 뿐인 장례, 다른 가족의 후기를 꼭 확인하세요</b> <br />
          <span className="caption_12_b">
            (*해당 장례식장이 아닌 고이장례연구소 이용 후기입니다.)
          </span>
        </Box>
      </VStack>
      <Spacing gap={6} />
      <VStack padding="6px 16px">
        <SelectedReviews
          title={<>후기 평균 4.9점, 진짜 고객이 말합니다.</>}
          path="parlor_detail"
          headingAs="h2"
        />
      </VStack>
      <Box width="100%">
        <GoiMessage
          event={{
            path: "parlor_detail",
            trigger_and_target: "uv_intro",
          }}
          title={
            <>
              숨김없는 장례의 시작 <br />
              고이장례연구소
            </>
          }
        />
      </Box>
    </>
  );
};

export default PriceInfoTabPanel;

// const ParlorImagesSection = ({ parlor }: { parlor: ParlorDetailProps }) => {
//   const router = useRouter();

//   return (
//     <VStack spacing={0} maxWidth="480px">
//       <>
//         <Spacing gap={80} />
//         <Box padding="0px 20px">
//           <Image
//             src={getCdnImageSrc("images/parlor/parlor-section-00-251202.png")}
//             alt="시설, 거리, 비용 등 고려할 것이 많은 장례식장 알아보기"
//           />
//           <Spacing gap={80} />
//         </Box>
//       </>

//       <>
//         <Image
//           src={getCdnImageSrc("images/parlor/parlor-section-01-251202.png")}
//           alt="고이에서 장례 전문가와 함께 무료 상담부터 받아보세요"
//         />
//         <Spacing gap={80} />
//       </>

//       <Box>
//         <Image
//           src={getCdnImageSrc("images/parlor/parlor-section-02-251202.png")}
//           alt="장례식장, 화장장 등 시설 비교부터 현실적인 전문가의 조언까지"
//         />
//         <Spacing gap={20} />
//         <Box padding="0px 20px">
//           <LargeButton
//             onClick={() => {
//               router.push(`/match/parlor-requests/${parlor.id}`);

//               customEvent({
//                 newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
//               });
//               customEvent({
//                 newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
//               });
//               customEvent({
//                 newGtm: {
//                   path: "parlor_detail",
//                   trigger_and_target: "CTA-uv_match_request_top",
//                 },
//               });
//             }}
//             buttonType={LARGEL_BUTTON_TYPE.DEFAULT}
//           >
//             무료 상담 신청하기
//           </LargeButton>
//         </Box>
//         <Spacing gap={152} />
//       </Box>

//       <Box padding="0px 20px">
//         <Image
//           src={getCdnImageSrc("images/parlor/parlor-section-03-251202.png")}
//           alt="업게 최초 정찰제 도입, 사용하지 않은 품목 100% 공제, 추가 비용없는 장례"
//         />
//         <Spacing gap={120} />
//       </Box>

//       <>
//         <Box padding="0px 20px">
//           <ParlorSectionReviews />
//         </Box>
//         <Spacing gap={80} />
//       </>

//       <Box padding="0px 20px">
//         <Image
//           src={getCdnImageSrc("images/parlor/parlor-section-04-251202.png")}
//           alt="폐업, 해지 위약금 없는 믿을 수 있는 상조, 정부가 검증한 소비자 중심 기업"
//         />
//         <Spacing gap={80} />
//       </Box>

//       <>
//         <GlobalCollaborationSection
//           top={
//             <Box className="head_24_b">
//               중소벤처기업부, 서울대학교 등<br />
//               신뢰도 높은 기관들과 함께합니다.
//             </Box>
//           }
//         />
//         <Spacing gap={80} />
//       </>

//       <Box>
//         <Box padding="0px 20px">
//           <Image src={getCdnImageSrc("images/parlor/parlor-section-05-251202.png")} alt="" />
//           <Spacing gap={32} />
//           <LargeButton
//             onClick={() => {
//               router.push("/service/");
//               customEvent({
//                 newGtm: { path: "parlor_detail", trigger_and_target: "uv_service_btm" },
//               });
//             }}
//             buttonType={LARGEL_BUTTON_TYPE.DEFAULT}
//           >
//             전체 서비스 확인하기
//           </LargeButton>
//           <Spacing gap={8} />
//           <LargeButton
//             onClick={() => {
//               customEvent({
//                 newGtm: { path: "parlor_detail", trigger_and_target: "call_btn-call" },
//               });
//               call("1666-9784");
//             }}
//             buttonType={LARGEL_BUTTON_TYPE.DEFAULT}
//           >
//             빠르게 전화 문의하기
//           </LargeButton>
//         </Box>
//         <Spacing gap={80} />
//       </Box>

//       <ParlorEndingSection
//         onClick={() => {
//           router.push("/funeral-prepare/company-introduction/");
//           customEvent({
//             newGtm: {
//               path: "parlor_detail",
//               trigger_and_target: "uv_intro",
//             },
//           });
//         }}
//       />
//     </VStack>
//   );
// };

// interface ParlorEndingSectionProps {
//   title?: string;
//   description?: string;
//   onClick: () => void;
// }

// const ParlorEndingSection = ({
//   title = "숨김없는 장례의 시작",
//   description,
//   onClick,
// }: ParlorEndingSectionProps) => {
//   return (
//     <VStack
//       width="100%"
//       className="body_18_r white"
//       alignItems="start"
//       spacing={0}
//       minHeight="748px"
//       css={{
//         padding: "24px 20px",
//         backgroundImage: `url(${getCdnImageSrc("images/parlor/parlor-section-06-251202.png")})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//       }}
//     >
//       <Box>
//         <ColorIcon name="logo" color={colors.white} size="48px" />
//       </Box>
//       <Spacing gap={32} />

//       <Box className="head_28_b white" margin="0 0 24px 0">
//         {title}
//       </Box>
//       <Spacing gap={16} />

//       <VStack gap="16px">
//         <Box className="body_16_m white">
//           고이는 상주님이 고인을 애도하는 일에만
//           <br /> 집중하도록 돕는, 본질에 집중하는 상조를
//           <br /> 만들고 싶은 사람들이 모여서 만들었습니다.
//           <br />
//           <br />
//           수많은 정보를 가려내는 데에 시간과 마음을
//           <br /> 낭비하지 않고, 추모에만 집중할 수 있도록
//           <br />
//           <br />
//           우리의 마지막이 아름다울 수 있도록
//           <br /> 깊이있는 장례를 만들어갑니다.
//         </Box>
//       </VStack>
//       <Spacing gap={32} />

//       <button
//         className="body_16_m gray900"
//         css={{
//           padding: "8px 18px",
//           borderRadius: "6px",
//           background: colors.white,
//         }}
//         onClick={onClick}
//       >
//         더 알아보기
//       </button>
//     </VStack>
//   );
// };

// const REVIEW_TAGS = [
//   "장례식장 비교,할인",
//   "친절하고 전문적인 상담",
//   "세심하게 챙기는 장례지도사",
//   "바가지 없는 장례 용품",
// ] as const;

// type ReviewTag = typeof REVIEW_TAGS[number];

// const ParlorSectionReviews = () => {
//   const router = useRouter();
//   const [selectedTag, setSelectedTag] = useState<ReviewTag>(REVIEW_TAGS[0]);

//   // 선택된 태그에 따라 리뷰 필터링 (bestReviews 키와 매핑)
//   const TAG_TO_KEY: Record<ReviewTag, keyof typeof bestReviews> = {
//     "장례식장 비교,할인": "0",
//     "친절하고 전문적인 상담": "1",
//     "세심하게 챙기는 장례지도사": "2",
//     "바가지 없는 장례 용품": "3",
//   };

//   const filteredReviews = bestReviews[TAG_TO_KEY[selectedTag]] ?? [];

//   return (
//     <VStack maxWidth="480px">
//       {/* 헤더 */}
//       <VStack alignItems="start" width="100%">
//         <Box className="head_24_b gray900" width="100%">
//           후기가 증명하는
//           <br />
//           마지막까지 만족스러운 장례
//         </Box>
//         <Spacing gap={16} />
//         <Box className="body_16_r gray700">
//           고객님들이 직접 남겨주신 후기 1200건 이상
//           <br />
//           서비스 만족도 평균 4.9점
//         </Box>
//       </VStack>
//       <Spacing gap={40} />

//       {/* 태그 칩들 */}
//       <HStack flexWrap="wrap" rowGap={"6px"} columnGap={"6px"}>
//         {REVIEW_TAGS.map((tag) => (
//           <Chip
//             key={tag}
//             className="body_14_m"
//             color={tag === selectedTag ? colors.white : colors.gray700}
//             background={tag === selectedTag ? colors.gray900 : colors.gray50}
//             padding="4px 12px"
//             text={`# ${tag}`}
//             onClick={() => setSelectedTag(tag)}
//             css={{
//               margin: "0px !important",
//             }}
//           />
//         ))}
//       </HStack>

//       <Spacing gap={24} />

//       {/* 리뷰 카드들 */}
//       <VStack width="100%" maxWidth="480px" alignItems="center" justifyContent="center">
//         {filteredReviews.map((review, index) => (
//           <ReviewCardRenewal
//             isFittedWidth
//             key={review.id}
//             {...review}
//             isCurrent={true}
//             event={{
//               path: "parlor_detail",
//               trigger_and_target: "review_detail",
//             }}
//           />
//         ))}
//       </VStack>

//       <Spacing gap={24} />
//       <LargeButton
//         buttonType={LARGEL_BUTTON_TYPE.DEFAULT}
//         css={{ padding: "16px 20px" }}
//         onClick={() => {
//           router.push("/review");
//           customEvent({
//             newGtm: {
//               path: "parlor_detail",
//               trigger_and_target: "selected_review-uv_review",
//             },
//           });
//         }}
//       >
//         <Box className="body_16_m">고이 후기 전체보기</Box>
//       </LargeButton>
//     </VStack>
//   );
// };
